<script setup lang="ts">
import { MapPin } from 'lucide-vue-next'
import {computed, onMounted} from 'vue'
import {label} from "../../mixins/translations";
import {useCourseStore} from "../../stores/course";
import {useGeoLocationStore} from "../../stores/geolocation";

interface Props{
    filters: { [key: string]: string }
}
const props = defineProps<Props>();

const courseStore = useCourseStore();
const geoLocationStore = useGeoLocationStore();

const months = courseStore.getRemainingMonths();

const searchQuery = computed({
    get: () => geoLocationStore.searchQuery,
    set: (value) => geoLocationStore.setSearchQuery(value, true)
})
const radius = computed({
    get: () => geoLocationStore.radius,
    set: (value) => geoLocationStore.setRadius(value)
})
const monthFilter = computed({
    get: () => courseStore.month,
    set: (value) => courseStore.setMonth(value)
})

const resetFilters = () => {
    geoLocationStore.resetFilters();
    monthFilter.value = 0;
}

onMounted(() => {
    if(Object.hasOwn(props.filters, 'straal')){
        geoLocationStore.setRadius(props.filters['straal'], false);
    }
    if(Object.hasOwn(props.filters, 'maand')){
        monthFilter.value = props.filters['maand'];
    }
    if (Object.hasOwn(props.filters, 'plaats')) {
        geoLocationStore.setSearchQuery(props.filters['plaats'], false, true); //On mount/prefilled search eerste resultaat direct selecteren
    }
});
</script>
<template>
    <div class="flex flex-wrap items-center gap-3">
        <div class="relative">
            <MapPin class="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-black" strokeWidth="1" />
            <input type="text" v-model="searchQuery" :placeholder="label('site.location.filter.city')" class="rounded-md border border-gray-300 pl-9 pr-4 py-2 text-sm"/>

            <div class="w-full absolute bg-gray-50 shadow-xl rounded-xl" ref="target">
                <div v-for="prediction in geoLocationStore.locationPredictions" class="w-full py-2 px-4 border-t border-gray-200 bg-gray-100 cursor-pointer" @click.prevent="geoLocationStore.selectLocation(prediction, 'beschikbare-data');">
                    {{ prediction.label }}
                </div>
            </div>
        </div>

        <select class="rounded-md border border-gray-300 pl-4 pr-10 py-2 text-sm text-gray-500" v-model="radius">
            <option value="0">{{ label('site.location.filter.radius') }}</option>
            <option v-for="(label, value) in geoLocationStore.radiusOptions" :value="value">{{ label }}</option>
        </select>

        <select class="rounded-md border border-gray-300 pl-4 pr-10 py-2 text-sm text-gray-500" v-model="monthFilter">
            <option value="0">{{ label('site.location.filter.month') }}</option>
            <option v-for="month in months" :value="month.value">{{ month.label }}</option>
        </select>

        <button class="rounded-md border border-gray-300 px-6 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-100 transition" @click.prevent="resetFilters();">
            {{ label('site.location.filter.reset') }}
        </button>
    </div>

</template>
